import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import useStockGroups from './useStockGroups';
const useCategoryFilterDetails = (id, type, selectedFilter) => {
    const [searchResults, search, loading, count] = useStockGroups(id, type, selectedFilter);
    const currentPriceCache = useAppSelector((state) => state.invest.currentPriceCaches);
    const priceChangeCache = useAppSelector((state) => state.invest.priceChangeCaches);
    const assetArr = useMemo(() => {
        const assets = searchResults ? [] : null;
        if (currentPriceCache && priceChangeCache && searchResults) {
            searchResults.forEach((searchResult) => {
                const currentPriceForStock = currentPriceCache[searchResult.id]?.value;
                const sharePriceChangePctForStock = priceChangeCache[searchResult.id]?.percent;
                if (currentPriceForStock && sharePriceChangePctForStock) {
                    assets?.push({
                        ...searchResult,
                        sharePrice: currentPriceForStock,
                        sharePriceChangePct: sharePriceChangePctForStock,
                    });
                }
            });
        }
        return assets;
    }, [currentPriceCache, priceChangeCache, searchResults]);
    return [assetArr, loading, count, search];
};
export default useCategoryFilterDetails;
